import { IDropdownStyles } from "@fluentui/react";

const mainColor = "#cc214F"

export const dropdownStylesMultiple: Partial<IDropdownStyles> = {
    caretDown:
    {
        color: mainColor,
        fontSize: "14px",
        fontWeight: 700,
    },
    dropdownItems:
    {
        color: "white",
        borderColor: "transparent",
        fontWeight: 500,
        fontSize: "20px",
        marginTop: "5px",
    },
    title:
    {
        color: `${mainColor} !important`,
        borderColor: "transparent !important",
        fontWeight: 500,
        fontSize: "20px",
        marginTop: "5px"
    },
    dropdownItemSelected:
    {
        backgroundColor: "white !important",
    },
    dropdownOptionText: { color: mainColor, }
};

export const dropdownStylesSingle: Partial<IDropdownStyles> = {
    caretDown:
    {
        color: mainColor,
        fontSize: "14px",
        fontWeight: 700,
    },
    dropdownItems:
    {
        color: "white",
        borderColor: "transparent",
        fontWeight: 500,
        fontSize: "20px",
        marginTop: "5px",
    },
    title:
    {
        color: `${mainColor} !important`,
        borderColor: "transparent !important",
        fontWeight: 500,
        fontSize: "20px",
        marginTop: "5px"
    },
    dropdownItemSelected:
    {
        backgroundColor: mainColor,
    },
    dropdownOptionText: { color: mainColor, }
};